import React from "react";
import { motion } from "framer-motion";
import { useT } from "@/context/LanguageContext";

export default function Gallery({ images = [] }) {
  const { t, ui } = useT();
  const pics = images.slice(0, 6);
  return (
    <section
      id="galeria"
      className="relative bg-[color:var(--gcs-ivory-2)] py-24 md:py-40 overflow-hidden"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("gallery.chapter")}</p>
            <span className="font-serif italic text-6xl md:text-7xl text-[color:var(--gcs-gold)]/40">
              /{String(pics.length).padStart(2, "0")}
            </span>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-[color:var(--gcs-emerald)]">
              {ui("gallery.h1_a")}<em className="text-[color:var(--gcs-gold)]">{ui("gallery.h1_em")}</em>{ui("gallery.h1_b")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-6 md:grid-cols-12 gap-4 md:gap-6">
          {pics.map((img, i) => {
            const layouts = [
              "col-span-6 md:col-span-7 aspect-[4/3]",
              "col-span-6 md:col-span-5 aspect-[4/5]",
              "col-span-6 md:col-span-4 aspect-square",
              "col-span-6 md:col-span-4 aspect-[3/4]",
              "col-span-6 md:col-span-4 aspect-square",
              "col-span-6 md:col-span-12 aspect-[21/9]",
            ];
            const cap = t(img.caption);
            return (
              <motion.figure
                key={img.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className={`zoom-frame relative bg-[color:var(--gcs-emerald)] rounded-sm ${layouts[i] || "col-span-6 aspect-[4/3]"}`}
                data-testid={`gallery-item-${i}`}
              >
                <img src={img.url} alt={cap || `Gallery ${i}`} className="w-full h-full object-cover" />
                {cap && (
                  <figcaption className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-[color:var(--gcs-ivory)]">
                    <span className="h-px w-6 bg-[color:var(--gcs-gold)]" />
                    <span className="overline text-[color:var(--gcs-gold)]">{cap}</span>
                  </figcaption>
                )}
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
